/**
 * Tokens de UI compartidos entre BaseTemplateBlack y SiteLayout (modo oscuro).
 * Un solo origen evita desalineaciones visuales entre la home y /portfolio, /audiovisual, etc.
 */

export const baseTemplateDarkShell = {
  pageRoot: "min-h-screen bg-black text-white font-body antialiased",
  header:
    "sticky top-0 z-50 w-full border-b border-white/10 bg-neutral-950 supports-[backdrop-filter]:bg-neutral-950/95 backdrop-blur-md pt-[env(safe-area-inset-top,0px)] shadow-[0_8px_24px_-12px_rgba(0,0,0,0.5)]",
  logoLink:
    "inline-flex items-center gap-2 text-lg sm:text-xl font-display font-medium text-white whitespace-nowrap tracking-wider hover:opacity-90 transition-opacity",
  navDesktopLink:
    "font-body text-white/60 hover:text-white transition-colors duration-300 font-medium focus:outline-none focus:ring-2 focus:ring-white/20 rounded tracking-wide text-sm",
  navDesktopLinkActive:
    "font-body text-white transition-colors duration-300 font-medium focus:outline-none focus:ring-2 focus:ring-white/20 rounded tracking-wide text-sm",
  mobileMenuPanel: "md:hidden border-t border-white/10 bg-neutral-950",
  mobileNavLink:
    "block px-3 py-2 font-body text-white/60 hover:text-white transition-colors font-medium tracking-wide",
  menuButton:
    "text-white/60 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/20 rounded",
  /** CTA tipo “glass” en hero (cumple, wishlist internacional) */
  ctaGlass:
    "inline-flex items-center gap-3 py-3.5 px-5 bg-white/[0.08] backdrop-blur-[16px] border border-white/[0.15] rounded-[14px] hover:bg-white/[0.12] hover:border-white/[0.25] transition-all duration-200 max-w-[360px] mx-auto",
} as const;
